/*
  Stamped reload cache (Temporary, for transfert from BigCommerce)
*/
/*jQuery(document).ready(function(){
  let stampedReloadInterval = setInterval(function(){
    if(typeof StampedFn === "object"){
      StampedFn.reloadUGC();
      StampedFn.loadBadges();
      clearInterval(stampedReloadInterval);
    }
  },500);
});*/

/**
 * Scroll Up/Down - Affichage MENU (mobile)
 */

$(window).bind('scroll', function(event) {
    if (event.originalEvent.wheelDelta >= 0 || jQuery(window).scrollTop() <= 100) {
        //console.log('Scroll up');
        jQuery("header").attr("data-show-cellmnu","true");
      
    }
    else {
        //console.log('Scroll down');
        jQuery("header").attr("data-show-cellmnu","false");
        
        jQuery('.zn_mnu_mobile_wrp').slideUp(500);
        jQuery('#lines').attr("data-close-nav",false);
      
    }
});

/**
 * Scroll Up/Down - Affichage MENU (mobile)
 */



(function(window){
	window.htmlentities = {
		/**
		 * Converts a string to its html characters completely.
		 *
		 * @param {String} str String with unescaped HTML characters
		 **/
		encode : function(str) {
			return jQuery("<div/>").text(str).html();
		},
		/**
		 * Converts an html characterSet into its original character.
		 *
		 * @param {String} str htmlSet entities
		 **/
		decode : function(str) {
			return jQuery("<div/>").html(str).text();
		}
	};
})(window);


window.mobilecheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};


/**
* Video Player Handler
*/

var dd_videoHandlerObject;
//Declare the dd_videoHandler
var dd_videoHandler = function(){
  this.videoPlayerID = "#video_use_underarms";
  this.videoCloseClass = ".close_video_use_underarms";
  this.videoContainerID = "#ppdd_vidwrp_ytVid";
  this.isOpened = false;
}
dd_videoHandler.prototype.init = function(){

	var thisObject = this;

	//When clicking on a "dd_video_play_btn" button element
	jQuery(document).on("click keydown",".dd_video_play_btn",function() {

		if (event.type === "keydown") {
			const isEnterOrSpace = event.key === "Enter" || event.key === " ";
			if (!isEnterOrSpace) return;
			
			if (event.key === " ") event.preventDefault();
		}
		
		const url = jQuery(this).attr("data-url");
		if(!url || url ==""){return false;}

		thisObject.openVideo(url);
	});

	//When clicking to close the video player
	jQuery(document).on("click keydown",this.videoCloseClass,function() {
		thisObject.closeVideoPlayer();
	});

};
dd_videoHandler.prototype.openVideo = function(url){

	if(!this.isOpened){
		jQuery(this.videoPlayerID).fadeIn()
	}

	jQuery(this.videoContainerID).empty();
	jQuery("<video />", {
		id: 'dd_video_embed',
		src: url,
		type: 'video/mp4',
		controls: true,
		autoplay: true
	}).appendTo(this.videoContainerID);

	this.isOpened = true;
};
dd_videoHandler.prototype.closeVideoPlayer = function(){
	jQuery(this.videoContainerID).empty();
	jQuery(this.videoPlayerID).fadeOut();
	this.isOpened = false;
};
dd_videoHandlerObject = new dd_videoHandler();

jQuery(document).ready(function(){
    //Initiate the events (buttons ...)
    dd_videoHandlerObject.init();
});
/**
* END  Player Handler
*/
/**
* Zendesk
*/

let dd_zendesk = function(){
  this.initiated = false;
  this.zKey = "ff119f36-ac1e-464c-9df6-0f8469533592";
  this.zendeskScript;
  this.zeCheckInterval;
};

dd_zendesk.prototype.init = function(){

  let thisObject = this;
  jQuery(document).on("click","#btnozdesk",function() {
      if(!thisObject.initiated){
          thisObject.initiated = true;
          thisObject.loadZendeskScript();
      }
  });

};

dd_zendesk.prototype.loadZendeskScript = function(){
  let thisObject = this;
  thisObject.zendeskScript = document.createElement('script');
  const scriptURL ='https://static.zdassets.com/ekr/snippet.js?key='+thisObject.zKey;

  thisObject.zendeskScript.setAttribute(
   'src',
   scriptURL,
  );

  thisObject.zendeskScript.setAttribute(
   'id',
   'ze-snippet',
  );

  thisObject.zendeskScript.setAttribute('async', '');
  document.head.appendChild(thisObject.zendeskScript);

  //Check if zE is initialized
  thisObject.zeCheckInterval = setInterval(function(){
      if(typeof zE !== "undefined"){
          zE('messenger', 'open');
          clearInterval(thisObject.zeCheckInterval);
          jQuery("#btnozdesk").hide();
      }
  },500);

};

let dd_zendeskObject = new dd_zendesk();

jQuery(document).ready(function(){
    //Initiate the events (buttons ...)
    dd_zendeskObject.init();
});

/**
* End Zendesk
*/



/* Countdown Handler */

	function dd_trackCountdowns(){
	jQuery(".dd_countdown_s").each(function(){
		
		const dom_elt = jQuery(this);
		
		const countDown_to = jQuery(this).attr("data-date_to");
		if(!countDown_to)return false;
		
		const countDown_alreadyDone = jQuery(this).attr("data-done");
		if(countDown_alreadyDone)return false;
		
		
		// Set the date we're counting down to
		let countDownDate = new Date(countDown_to).getTime();

		// Update the count down every 1 second
		let x = setInterval(function() {

		  // Get today's date and time
		  let now = new Date().getTime();
			
		  // Find the distance between now and the count down date
		  let distance = countDownDate - now;
			
		  // Time calculations for days, hours, minutes and seconds
		  let days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString();
          if(days.length < 2){ days = ""+days}
		  let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString();
          if(hours.length < 2){ hours = "0"+hours}
		  let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
          if(minutes.length < 2){ minutes = "0"+minutes}
		  let seconds = Math.floor((distance % (1000 * 60)) / 1000).toString();
          if(seconds.length < 2){ seconds = "0"+seconds}
		  
		  // Output the result 
		  //dom_elt.html(hours + ":"+ minutes + ":" + seconds);


          
          if (days > 15) {
			dom_elt.html(days + " day left");
		  }
          else {
                dom_elt.html(hours + ":"+ minutes + ":" + seconds);
          }

          
			
		  // If the count down is over, write some text 
		  if (distance < 0) {
			clearInterval(x);
			dom_elt.html("00:00:00");
		  }
		}, 1000);
		jQuery(this).attr("data-done","true");
	});
}
    jQuery(document).ready(function(){
       dd_trackCountdowns();
    });

/**
* End Countdown Handler
*/




